export default __webpack_public_path__ + "static/media/archi_view4_c.34e393cc.webp";